export default {
    shareScreen: "Would you like to share your screen?",
    no: "না",
    yes: "হ্যা",
    youmustpickastar: "You must pick a calification",
    name: "নাম",
    email: "ইমেইল",
    phone: "ফোন",
    message: "আপনার কথা",
    sendMessage: "বার্তা পাঠান",
    newConversation: "নতুন কথোপকথন",
    sendpunctuation: "আপনার মতামত",
    musttypemail: "আপনার ইমেইল এড্রেসটি দেয়ার জন্য ধন্যবাদ",
    validemail: "ইমেইল এড্রেসটি সঠিক নয়",
    musttypename: "আপনার নাম দেয়ার জন্য ধন্যবাদ",
    musttypemessage: "আপনার মতামত বা জিজ্ঞাসা আমাদের জানান",
    configuration: "কনফিগারেশন",
    notifications: "নোটিফিকেশন",
    notificationDetails: "নতুন কথোপকথনগুলো আমাকে জানানো হোক",
    close: "শেষ",
    cancel: "বাদ",
    save: "সেভ করুন",
    willclose: "কথোপকথন শেষ",
    closeconf: "কথোপকথন শেষ হলে আবার কন্ফার্ম করুন",
    newmessage: "নতুন কথোপকথন",
    typehere: "আপনার কথা",
    whatdoyouthink: "আমাদের চ্যাট সার্ভিসটি আপনার কেমন লাগলো?",
    sendbymail: "কথোপকথনটি ইমেইলে পাঠিয়ে দিন",
    holdtimeavg: "অ্যাভারেজ হোল্ড টাইম",
    holdtime: "আপনার হোল্ড টাইম",
    messagesended: "আপনার কথা পাঠানো হয়েছে",
    emailerror: "দয়া করে সঠিক ইমেইল এড্রেস দিন",
    messageserror: "সাময়িক অসুবিধার জন্য আন্তরিক দুঃখিত :(",
    message: "আপনার কথা",
    transfering: "অনুগ্রহ করে অপেক্ষা করুন",
    endchat: "কথোপকথন শেষ",
    videocall: "ভিডিও কল",
    call: "কল",
    openinextarnalwindow: "নতুন উইন্ডো",
    calling: "কল……",
    callingduration: "কলের সময়",
    mute: "সাউন্ড বন্ধ",
    allowmicrophone: "মাইক্রোফোন ব্যবহারে অনুমতি দিন",
    hangup: "কথোপকথন শেষ",
    callonhold: "কল হোল্ডে আছে",
    duration: "সময় ",
    write: "লিখুন",
    survey_title: 'আশা করছি আমাদের সার্ভিসে আপনি আনন্দিত।',
    survey_desc: "আমাদের চ্যাট সার্ভিস সম্পর্কে আপনার মতামত অত্যন্ত গুরুত্বপূর্ণ। অনুগ্রহ করে আপনার মতামত এখন অথবা পরবর্তীতে জানান।",
    available: "Available",
    invalidextension: "সংযুক্তি বিন্যাস অবৈধ৷",
    maxfilesize10mb: "সর্বাধিক ফাইলের আকার 10 এমবি",
    accessiblity: "অ্যাক্সেসিবিলিটি",
    accessibilityMenu: "অ্যাক্সেসিবিলিটি মেনু",
    "Font size": "ফন্টের আকার",
    emojis: {
        search: "অনুসন্ধান করুন",
        notfound: "কোন ইমোজি পাওয়া যায়নি",
        title: "একটি ইমোজি নির্বাচন করুন",
        categories: {
            search: "অনুসন্ধান ফলাফল",
            recent: "সাম্প্রতিকভাবে ব্যবহৃত",
            people: "মুখোমুখি এবং মানুষ",
            nature: "প্রাণী এবং প্রাকৃতিক",
            foods: "খাদ্য এবং পানি",
            activity: "কার্যক্রম",
            places: "ভ্রমণ এবং স্থান",
            objects: "বস্তু",
            symbols: "প্রতীক",
            flags: "ঝড়পাতা",
            custom: "কাস্টম",
        },
    },
};